/* eslint-disable import/prefer-default-export */
import * as API from "middleware/api";

export const filterCedipsList = (params) => API.executeWithAccessToken("/list.cedips", { ...params });

export const sendTransmitCedipPreview = (params) =>
    API.executeWithAccessToken("/transmit.cedip.preview", { ...params });
export const acceptTermTransmitCedip = (params) =>
    API.executeWithAccessToken("/transmit.cedip.accept.term", { ...params });
export const signTransmitCedip = (params) => API.executeWithAccessToken("/transmit.cedip.send", { ...params });
export const sendTransmitAdmitCedip = (params) =>
    API.executeWithAccessToken("/transmit.admit.cedip.send", { ...params });
export const sendTransmitAnulateCedip = (params) =>
    API.executeWithAccessToken("/transmit.anulate.cedip.send", { ...params });
export const sendTransmitRepudiateCedip = (params) =>
    API.executeWithAccessToken("/transmit.repudiate.cedip.send", { ...params });

export const downloadDetailCedip = (cedip, fileFormat) =>
    API.executeWithAccessToken("/cedip.downloadDetailCedip", {
        cedip,
        format: fileFormat,
    });
